import { appUrl } from 'utils/wrappers';

import PageableBase from 'app/collections/pageable_base';
import Event from 'app/models/event';

export default PageableBase.extend({
  model: Event,
  key: 'events',
  url: appUrl('events'),
});



// WEBPACK FOOTER //
// ./app/collections/events.js